<template lang="pug">
div
  .payment-order-form_item
    payment-order-deposit-form( :form="form" @cleanForm="handleCleanForm" @formChanged="handleFormChange" @handleSummInput="handleSummInput" )
    payment-order-individual-payer-form( v-if="form.personaType == getPersonaType('FL')" :form="form" @formChanged="handleFormChange" )
    slot
    app-button( v-if="step >= 1 && form.personaType == getPersonaType('FL')" color="primary" :disabled="!isReadyToFillPaymentOrder" @click="fillPaymentOrder(form)" ) Сгенерировать QR-код

  .payment-order-form_item( v-if="step > 1 && form.personaType == getPersonaType('FL')")
    app-text-field( v-model="form.payerInn" label="ИНН плательщика" hideDetails dense :rules="[rules.inn]" )
    payment-order-bank-account-form( :form="form")
    app-button( color="primary" :disabled="!isReadyToPrintPaymentOrder" @click="printPaymentOrder(form)" ) Распечатать платежное поручение

  .payment-order-form_item( v-if="form.personaType == getPersonaType('UL')" )
    payment-order-entity-payer-form( :form="form" )
    payment-order-bank-account-form( :form="form" )
    app-button( color="primary" :disabled="!isReadyToPrintPaymentOrder" @click="printPaymentOrder(form)" ) Распечатать платежное поручение
    .d-flex.justify-center
      a( v-if="isReadyToPrintPaymentOrder" @click="printPaymentOrderForUL(form)" ) Экспорт в банк-клиент
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import PaymentOrderDepositForm from '@/pages/paymentOrder/forms/PaymentOrderDepositForm.vue'
import PaymentOrderEntityPayerForm from '@/pages/paymentOrder/forms/PaymentOrderEntityPayerForm.vue'
import PaymentOrderIndividualPayerForm from '@/pages/paymentOrder/forms/PaymentOrderIndividualPayerForm.vue'
import PaymentOrderBankAccountForm from '@/pages/paymentOrder/forms/PaymentOrderBankAccountForm.vue'
import { ExpertPayment } from '../../models/payment.order.form.models'
import { PersonaType } from '../../models/payment.order.form.models'
import { $_validate_rules } from '@/common/ValidateRules'

export default {
  mixins: [ $_validate_rules ],

  components: {
    PaymentOrderDepositForm,
    PaymentOrderEntityPayerForm,
    PaymentOrderIndividualPayerForm,
    PaymentOrderBankAccountForm
  },

  props: {
    sudAlias: { type: String, default: "" }
  },

  data() {
    return {
      priceError: false,
      form: new ExpertPayment(),
      step: 1
    }
  },

  computed: {
    isReadyToFillPaymentOrder() {
      return this.form.isFirstFormReady && this.priceError
    },

    isReadyToPrintPaymentOrder() {
      return this.form.isFirstFormReady && this.form.isSecondFormReady && this.priceError
    }
  },

  methods: {
    ...mapActions('expert', ['getQrCode', 'getPaymentOrder', 'getPaymentOrderForUL']), 
    ...mapMutations('expert', ['setQRCodeImg']),
    getPersonaType(type) {
      return PersonaType[type].value
    },

    fillPaymentOrder(form) {
      if (this.step == 1) this.step++
      this.getQrCode(form)
    },

    setCourt(court) {
      this.form.courtCard = court?.id ?? ""
    },

    printPaymentOrder(form) {
      this.getPaymentOrder(form).then(data => {
        this.downloadPaymentOrder(data, 'Платежное поручение.pdf')
      })
    },

    printPaymentOrderForUL(form) {
      this.getPaymentOrderForUL(form).then(data => {
        this.downloadPaymentOrder(data, '1c_to_kl.txt')
      })
    },

    downloadPaymentOrder(data, fileName) {
      const url = URL.createObjectURL(data);
      const link = document.createElement('a');
  
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.addEventListener('click', () => {
        setTimeout(() => {
          URL.revokeObjectURL(url);
        });
      });
      link.click();
    }, 

    handleCleanForm() {
      if (this.step >= 2) this.step = 1
      this.form.cleanForm()
      this.setQRCodeImg(null)
    },

    handleFormChange(error) {
      if (error ?? null) this.priceError = !error.price
      this.setQRCodeImg(null)
    },

    handleSummInput(item) {
      this.form.summa = Number(item).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&')
    }
  }
}
</script>

<style scoped>
::v-deep.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined),
::v-deep.theme--dark.v-btn.v-btn--disabled {
  background-color: #BDBDBD !important;
  color: white !important;
}
.payment-order-form_item {
  display: flex; 
  gap: 15px; 
  flex-direction: column;
}
</style>